import React, { Component, MouseEvent } from "react";
import classnames from "classnames";

import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";
import { Icon } from "@formant/ui/component/common/Icon";
import { animate } from "@formant/ui/utils/animate";

import { IJumpSuggestion } from "../../../store/JumpStore";
import { jumpStore, routerStore } from "../../../stores";
import { Button } from "../../common/Button";
import * as styles from "./Suggestion.scss";

export interface ISuggestionProps extends ITestableComponentProps {
    index: number;
    suggestion: IJumpSuggestion;
    selected: boolean;
    onClicked: () => void;
    onSelect: (index: number) => void;
}

export class Suggestion extends Component<ISuggestionProps> {
    public render() {
        const { suggestion, selected } = this.props;
        const { type, title, to } = suggestion;

        return (
            <Button
                className={classnames(
                    styles.suggestion,
                    styles.button,
                    selected && styles.selected,
                )}
                to={to}
                onClick={this.onClick}
                onMouseEnter={this.onMouseEnter}
                data-testid={this.props["data-testid"]}
            >
                <Icon name={type} />
                <div className={styles.title}>{title}</div>
            </Button>
        );
    }

    private onClick = async (event: MouseEvent) => {
        event.preventDefault();
        const { suggestion, onClicked } = this.props;
        const { to } = suggestion;
        jumpStore.saveRecent(suggestion);
        onClicked();
        await animate();
        await routerStore.navigate(to);
    };

    private onMouseEnter = () => {
        const { index, onSelect } = this.props;
        onSelect(index);
    };
}
